import { AppBarGuardType, AppBarGuardObjectType } from '../type';

export const name = 'isMqAnimatingDown';

export const fn: AppBarGuardType = (context) => context.mqUp === 0 && context.mqAction === 1;

export const guard: AppBarGuardObjectType = {
  [name]: fn,
};

export default guard;
